import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {LoginView} from "../views/login";
import {App} from "../app/app";
import {LogoutView} from "../views/logout";
import {SignupView} from "../views/signup";

export class LoginFunction extends AppFunction {

    readonly v : View;

    constructor(app: App, username?: string, password?: string) {
        super();
        this.v = new LoginView(app, username, password);
    }

    view() {
        return this.v;
    }

    url() {
        return `/login`;
    }

}


export class LogoutFunction extends AppFunction {

    readonly v : View;

    constructor(app: App) {
        super();
        this.v = new LogoutView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/logout`;
    }

}

export class SignupFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new SignupView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/signup`;
    }

}
